export default __webpack_public_path__ + "locales/ro/DeleteSelfProfileDialog.json?hash=9d9dbba7f620868732e5698820248c54";